import { compose, withProps } from 'recompose'
import { InputText } from './index'
import toReduxFormField from '../../../enhancers/ToReduxFormField'

export const formatPhone = value => {
  // If the user modifies digits within sections, it will pass the validation,
  // because we don't want to re-render all the time, which cause cursor jumping.
  if (!value) return ''
  if (/^\d{1,3}-\d{1,3}-\d{1,4}$/.test(value)) return value

  const clean = (value.match(/\d/g) || []).join('')
  const arr = clean.split('')
  arr.length > 3 && arr.splice(3, 0, '-')
  arr.length > 7 && arr.splice(7, 0, '-')
  arr.length > 12 && arr.splice(12, 1)
  return arr.join('')
}

const parsePhone = value => {
  if (!value) return ''
  return value.replace(/-/g, '')
}

const enhance = compose(
  withProps({
    format: formatPhone,
    parse: parsePhone,
  }),
  toReduxFormField('InputPhone'),
)

export default enhance(InputText)
